import { OrgEntitlements } from "../models/SubscriptionModels";
import { formatDate } from "../utils/DateTime";
import SubscriptionStatusBadge from "./SubscriptionStatusBadge";
import MessagingUsageBar from "./MessagingUsageBar";
import "./SubscriptionInfoCard.css";

interface SubscriptionInfoCardProps {
  entitlements: OrgEntitlements | null;
  loading?: boolean;
  onRefresh?: () => void;
}

const SubscriptionInfoCard = ({
  entitlements,
  loading = false,
  onRefresh,
}: SubscriptionInfoCardProps) => {
  if (loading) {
    return <div className="sub-card">Loading subscription…</div>;
  }

  if (!entitlements || !entitlements.hasActiveSubscription) {
    return (
      <div className="sub-card sub-card--inactive">
        <div className="sub-card__head">
          <h3 className="sub-card__title">Subscription</h3>
          <SubscriptionStatusBadge
            status={entitlements?.status ?? 0}
          />
        </div>
        <p className="sub-card__inactive-text">
          Your organization does not have an active subscription.
        </p>
        <p className="sub-card__contact">
          To activate or renew, contact the platform administrator.
        </p>
      </div>
    );
  }

  const { planName, planCode, endsAt } = entitlements;
  const maxBranches = entitlements.maxBranches;

  return (
    <div className="sub-card">
      <div className="sub-card__head">
        <h3 className="sub-card__title">Subscription</h3>
        <SubscriptionStatusBadge status={entitlements.status} />
      </div>

      <dl className="sub-card__grid">
        <div className="sub-card__field">
          <dt className="sub-card__label">Plan</dt>
          <dd className="sub-card__value">
            {planName ?? "—"}
            {planCode ? (
              <span className="sub-card__code"> /{planCode}</span>
            ) : null}
          </dd>
        </div>
        <div className="sub-card__field">
          <dt className="sub-card__label">Valid until</dt>
          <dd className="sub-card__value">{formatDate(endsAt)}</dd>
        </div>
        <div className="sub-card__field">
          <dt className="sub-card__label">Max branches</dt>
          <dd className="sub-card__value">{maxBranches}</dd>
        </div>
        <div className="sub-card__field">
          <dt className="sub-card__label">Messaging</dt>
          <dd className="sub-card__value">
            {entitlements.messagingEnabled ? "Enabled" : "Not included"}
          </dd>
        </div>
      </dl>

      {entitlements.messagingEnabled && (
        <MessagingUsageBar entitlements={entitlements} compact />
      )}

      <p className="sub-card__contact">
        To renew or upgrade, contact platform support.
      </p>

      {onRefresh && (
        <button
          type="button"
          className="sub-card__refresh"
          onClick={onRefresh}
        >
          Refresh
        </button>
      )}
    </div>
  );
};

export default SubscriptionInfoCard;